import React from 'react';

import BaseFilterTab from './base/BaseFilterTab';

const RenderFilterTabs = ({
  options,
  valueKey = 'value',
  labelKey = 'label',
  active,
  action,
}) => Object.values(options)
  .map((tab, i) => (
    <BaseFilterTab
      key={i}
      {...tab}
      valueKey={tab[`${valueKey}`]}
      labelKey={tab[`${labelKey}`]}
      active={active}
      action={action}
    />
  ));

export default RenderFilterTabs;